import styled, { css } from 'styled-components';
import { LinkButton } from '../LinkButton';
export { Table } from 'antd';
export const consoleTableMixin = css `
  thead tr th {
    background-color: ${({ theme }) => theme.greys.glamdring};
  }

  & tr.ant-table-expanded-row {
    background-color: ${({ theme }) => theme.greys.glamdring};
  }
`;
export const DangerLink = styled(LinkButton) `
  color: ${({ theme }) => theme.colors.coral};
`;
export const ConsoleTableHeader = styled.div `
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  align-items: center;
`;
export const ActionLink = styled(LinkButton) `
  color: ${({ theme }) => theme.colors.sudoBlue};
`;
